import React from "react";
import { Link } from "react-router-dom";
import "./NavBar.scss";
import logo from "frontend/assets/logo-large.png";

const NavBar = ({ authState, username, onLoginClick, onSignupClick, onLogoutClick, onMenuClick, menuOpen, hasPendingChallenges }) => {
  return (
    <nav className="modern-navbar">
      <div className="navbar-content">
        <div className="navbar-left">
          {/* No sidebar exists for anonymous visitors, so no hamburger. */}
          {authState !== 'anonymous' && (
            <div className="hamburger-wrap">
              <button
                className={`hamburger-btn ${menuOpen ? 'open' : ''}`}
                onClick={onMenuClick}
                aria-label="Toggle menu"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
              {hasPendingChallenges && (
                <span className="hamburger-badge">!</span>
              )}
            </div>
          )}
          <Link to="/" className="logo-link">
            <img src={logo} alt="King of 20" className="logo-image" />
          </Link>
        </div>

        <div className="navbar-right">
          {authState === 'registered' && (
            <div className="user-info">
              <Link to={`/users/${username}`} className="user-profile">
                <div className="user-avatar">
                  {username ? username.charAt(0).toUpperCase() : "U"}
                </div>
                <span className="username">{username || "User"}</span>
              </Link>
              <button className="btn-logout" onClick={onLogoutClick}>
                Logout
              </button>
            </div>
          )}

          {/* No profile link for guests -- /users/guest-k3mfq7 is a meaningless page. */}
          {authState === 'guest' && (
            <div className="guest-info">
              <span className="guest-label">Playing as Guest</span>
              {/* A returning player on a new device becomes a guest the moment
                  they tap Play now, so they need a route back to their account. */}
              <button className="btn-login" onClick={onLoginClick}>
                Login
              </button>
              <button className="btn-signup" onClick={onSignupClick}>
                Save progress
              </button>
            </div>
          )}

          {authState === 'anonymous' && (
            <div className="auth-buttons">
              <button className="btn-login" onClick={onLoginClick}>
                Login
              </button>
              <button className="btn-signup" onClick={onSignupClick}>
                Sign Up
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
